<script setup lang="ts">
import SaveButton from "@/components/SaveButton.vue";
import type { House } from "@/houses/types";
import { Xmark } from "@iconoir/vue";
import type { MutationStatus } from "@tanstack/vue-query";
import { ref, toRaw } from "vue";
import { RouterLink } from "vue-router";
import HouseFormFields from "./HouseFormFields.vue";

const props = defineProps<{
  house: House;
  updateHouseStatus: MutationStatus;
}>();

const house = ref(structuredClone(toRaw(props.house)));

defineEmits<{
  update: [house: House];
}>();
</script>

<template>
  <form class="column" @submit.prevent="$emit('update', house)">
    <HouseFormFields v-model="house" />
    <div class="row row-end">
      <RouterLink
        :to="{ name: 'houses' }"
        class="button button--secondary"
        role="button"
        ><Xmark /> Zurück zur Übersicht</RouterLink
      >
      <SaveButton :saving-status="updateHouseStatus">Speichern</SaveButton>
    </div>
  </form>
</template>
